<div class="container" fxLayout="row">
    <optsol-ngx-forgot-password-form (formSubmit)="submit($event)" [disableSubmitButton]="false" fxFlex="40%">
        <img brandImage [src]="environmentSettings.portalLogoUrl" width="50%" />
        <span title class="mat-h2">{{environmentSettings.portalName || 'Customer Portal'}}</span>
        <img poweredByImage [src]="environmentSettings.poweredByUrl" />
        <ng-container links>
            <a [routerLink]="['/']">Sign In</a>
        </ng-container>
    </optsol-ngx-forgot-password-form>
  </div>
